import { render, staticRenderFns } from "./dept-roles-view.vue?vue&type=template&id=32186164&scoped=true"
import script from "./dept-roles-view.vue?vue&type=script&lang=js"
export * from "./dept-roles-view.vue?vue&type=script&lang=js"
import style0 from "./dept-roles-view.vue?vue&type=style&index=0&id=32186164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32186164",
  null
  
)

export default component.exports